const statusFormatter = (row, column) => {
    const status = row[column.property]
    switch (status) {
        case 1:
            return "已收费"
        case 0:
            return "已预约"
        case -1:
            return "已取消"
        default:
            return status
    }
}

const data = {
    table: {
        columns: [
            { title: '状态', field: 'status', width: '100', formatter: statusFormatter },
        ],
        data: [],
        total: 0,
        page: 1,
        pageSize: 20
    },
}

export default data
